import { RadioField, RadioInput } from '@flos/react-ui';
import { useHippoText } from '../../../../hooks/useHippoText';
import CoverableDetailsTemplate from '../../../../templates/CoverableDetailsTemplate';
import WizardPagetemplate from '../../../../templates/WizardPagetemplate';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { useState } from 'react';
import { useUpdateCoverableInformation } from '../../../../recoil/hooks/useUpdateCoverableInformation';
import { track } from '../../../../utils/trackingUtil';
import { isRequestPendingAtom } from '../../../../recoil/atoms/isRequestPendingAtom';
import { shouldCoverCriticalIllnessAtom } from '../../../../recoil/atoms/shouldCoverCriticalIllnessAtom';

const HowShouldChildBeCovered = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const isRequestPending = useRecoilValue(isRequestPendingAtom);
    const setShouldCoverCriticalIllness = useSetRecoilState(shouldCoverCriticalIllnessAtom);
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const childCoverables = coverables.childAccidents ?? [];
    const coverableIndex = childCoverables?.findIndex(
        (coverable) => coverable.fixedId === currentProduct.fixedId
    );
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const [choice, setChoice] = useState<string>('');

    const handleChoiceChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = event.target;
        setChoice(value);
        setShouldCoverCriticalIllness(value === 'coverInIllnessAndCritialInjury');
        updateCoverableInformation({
            shouldCoverCriticalIllness: value === 'coverInIllnessAndCritialInjury'
        });
    };

    const onNext = (): void => {
        track(
            `${childCoverables[coverableIndex].flavourName}CoverableInformationHowShouldChildBeCovered`,
            [{ shouldCoverCriticalIllness: choice === 'coverInIllnessAndCritialInjury' }]
        );
        goNext();
    };

    return (
        <WizardPagetemplate
            onNext={onNext}
            onPrevious={goPrevious}
            disableNext={
                childCoverables[coverableIndex].shouldCoverCriticalIllness === undefined ||
                isRequestPending
            }
            disablePrevious={isRequestPending}
            isNextLoading={isRequestPending}
        >
            <CoverableDetailsTemplate
                header={getHippoText('DSS-COVERABLE-INFORMATION-STEP-CHILD-RISK-QUESTION-HEADER', {
                    coverable_first_name: childCoverables[coverableIndex].name ?? ''
                })}
            >
                <div className="u-display-flex u-flex-items-stretch u-flex-items-start u-gap-3 u-flex-column">
                    <RadioField
                        value={choice}
                        onChange={handleChoiceChange}
                        required
                        disabled={isRequestPending}
                    >
                        <RadioInput
                            label={getHippoText(
                                'DSS-COVERABLE-INFORMATION-STEP-CHILD-RISK-QUESTION-RADIO-BUTTON1'
                            )}
                            value="coverInIllnessAndCritialInjury"
                        />
                        <RadioInput
                            label={getHippoText(
                                'DSS-COVERABLE-INFORMATION-STEP-CHILD-RISK-QUESTION-RADIO-BUTTON-2'
                            )}
                            value="onlyIllness"
                        />
                    </RadioField>
                </div>
            </CoverableDetailsTemplate>
        </WizardPagetemplate>
    );
};

export default HowShouldChildBeCovered;
